import { ThCell } from '../../../../common/table/ThCell'

export const HeaderTable = ({ headerTable }) => {
  const headerWithChild = headerTable.filter((item) => item.childCol)

  return (
    <>
      <tr>
        {headerTable.map((col, colIndex) => {
          return (
            <ThCell
              key={colIndex}
              style={col.style}
              col={col}
              rowSpan={col.childCol ? 1 : 2}
              colSpan={col.childCol ? col.childCol.length : 1}
            />
          )
        })}
      </tr>
      <tr>
        {headerWithChild.map((parentCol) => {
          return parentCol.childCol.map((childCol, childColIndex) => {
            return (
              <ThCell
                key={childColIndex}
                style={childCol.style}
                col={childCol}
              />
            )
          })
        })}
      </tr>
    </>
  )
}
